'use client'

import { Button } from '@cocoonspace/ui/components/button'
import {
	CalendarIcon,
	HelpCircleIcon,
	LinkIcon,
	SearchIcon,
} from 'lucide-react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { ZONES } from '~/config/zones'
import { CartSheetTrigger } from '~/domains/cart/cart-sheet'
import { useLocale } from '~/hooks/use-locale.hook'
import { getLocalizedPath, stripLocaleFromPath } from '~/i18n/routing'
// import { HasExperiment } from '~/hooks/use-experiment'
import { UserMenu } from './user-menu'

const MyEventsButton = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const locale = useLocale()
	const isActive = pathname.includes('/events')

	return (
		<Button
			icon
			variant={isActive ? 'outlinePrimary' : 'ghost'}
			asChild
		>
			<Link href={getLocalizedPath('/events', locale)}>
				<CalendarIcon />
			</Link>
		</Button>
	)
}

const SchedulerButton = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const locale = useLocale()
	const isActive = pathname.includes('/scheduling')

	return (
		<Button
			icon
			variant={isActive ? 'outlinePrimary' : 'ghost'}
			asChild
		>
			<Link href={getLocalizedPath('/scheduling', locale)}>
				<LinkIcon />
			</Link>
		</Button>
	)
}

const SearchButton = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const locale = useLocale()
	const isActive = ZONES.some((zone) => pathname.includes(`/${zone}`))

	return (
		<Button
			icon
			variant={isActive ? 'outlinePrimary' : 'ghost'}
			asChild
		>
			<Link href={getLocalizedPath('/paris', locale)}>
				<SearchIcon />
			</Link>
		</Button>
	)
}

const HelpButton = () => {
	return (
		<Button
			icon
			variant='ghost'
			asChild
		>
			<Link
				href='https://support.cocoon-space.com'
				target='_blank'
			>
				<HelpCircleIcon />
			</Link>
		</Button>
	)
}

export const MobileNav = () => {
	return (
		<>
			<SearchButton />
			<MyEventsButton />
			<SchedulerButton />

			{/* <HasExperiment experimentId='carts-beta'> */}
			<CartSheetTrigger />
			{/* </HasExperiment> */}

			<HelpButton />
			<UserMenu />
		</>
	)
}
